import { WEB_RED_REG } from '@mnd-frontend/ui/shared/tokens';
import type { SVGProps } from 'react';
import { ReactComponent as Logo } from '../../../../shared/assets/svgs/mynewsdesk-logo.svg?react';

const MynewsdeskLogo = ({
  color = WEB_RED_REG,
  ...attrs
}: { color?: string } & SVGProps<SVGSVGElement>) => <Logo color={color} {...attrs} />;

export default MynewsdeskLogo;
